import { render, staticRenderFns } from "./GeneralItem.vue?vue&type=template&id=b6baa23c&"
import script from "./GeneralItem.vue?vue&type=script&lang=js&"
export * from "./GeneralItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports